export default __webpack_public_path__ + "static/media/bio-industrial.1ccd3179.svg";